
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../../../../services/home.service';
import { Order } from '../../../../interfaces/order';
import Swal from 'sweetalert2';
import { FormGroup } from '@angular/forms';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../../../services/user';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs';
import { ItemsService } from '../../../../services/items.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ClientsService } from '../../../../services/clients.service';
const CATEGORY_NAMES: Record<string, string> = {
  '0': 'soft food', '1': 'soft food can', '2': 'dry food', '3': 'bird food',
  '4': 'medicine', '5': 'supplement', '6': 'accessories', '7': 'toy',
  '8': 'grooming', '9': 'house', '10': 'care', '11': 'treats',
  '12': 'training pads', '13': 'bags', '14': 'cleaning tools', '15': 'litter'
};
@Component({
  selector: 'app-myclientspage',
  templateUrl: './myclientspage.component.html',
  styleUrl: './myclientspage.component.scss'
})
export class MyclientspageComponent {
  popupType: 'orders' | 'products' | null = null;
  showClientPopup: boolean = false;

  selectedOrders: any[] = [];
  selectedProducts: any[] = [];
  popupTitle: string = '';

  @Input() isProfile: string = "";
  userId: any;
  allData: Order[] = [];


  displayedColumns: string[] = ['client_name', 'phone_number', 'another_phone', 'address', 'orders', 'stocks', 'call', "chat", "reorder"];
  contentReady: boolean = true;
  noData: boolean = false;
  showPopUp: boolean = false;
  showRejectPopUp: boolean = false;
  orderchange!: FormGroup;
  reason: string = "";
  orderId!: any;
  statuslist: any;
  clear: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  stockTotal!: any;
  totalItems!: any;
  searched: boolean = false;
  isAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '1' || this.accountType == "10")
  );
  isSubAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '6')
  );
  showoptions: boolean = false;
  searchKey: string = '';
  isAr: boolean = localStorage.getItem("language") == "ar";
  dataSource: MatTableDataSource<any>;
  warehouseId!: any;
  allWareHouses: any;
  totaldebit: any;
  isWarehouse: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  warehouseIsStore: boolean = false;
  constructor(
    private router: Router,
    private _clientsService: ClientsService,
    private _profileService: ProfileService,
    private _ItemsService: ItemsService,
    private excelExportService: ExcelExportService,
    private _orders: ItemsService,
    private _userService: UserService,
  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isAdmin$.subscribe(value => console.log('isAdmin:', value));
    this.warehouseId = localStorage.getItem("posId");
    this._userService.getWarehouseType(Number(this.warehouseId)).subscribe({
      next: (data) => {
        if (data['warehouses_type'] == "4" || data['warehouses_type'] == "2") {
          this.warehouseIsStore = true;
          this.displayedColumns.push('addpet');
        }
        else if (data['warehouses_type'] == "1") {
          this.isWarehouse = true;
          this.displayedColumns.push('accountStatement');
        }
      }
    });
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";
        this.isSubAdmin = this.accountType == "6";

        if (!this.isAdmin && !this.isSubAdmin) {
          this._userService.getUserId().subscribe({
            next: (data) => {
              this.userId = data['user_id'];
              this.getAllClientsforUser(10, 1, data['user_id']);

            },
            error: (error) => console.error(error),
          });

        } else {


          this.getAllClients(10, 1, this.warehouseId);
        }


      },
      error: (error) => console.error(error),
    });
    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res.warehouse
      },
      error: (err) => {

      },
    });

  }
  checkWarehouseType(): void {
    this._userService
      .getWarehouseType(Number(this.warehouseId))
      .subscribe({
        next: ({ warehouses_type }) => {
          const type = Number(warehouses_type);

          // Set flag
          this.warehouseIsStore = type === 1;

          // Handle navigation
          if ([2, 3, 4].includes(type)) {
            this.router.navigate(['/Addorderstore']);
            return;
          }

          else if (type === 1) {
            this.router.navigate(['/Addorderwarehouse']);
            return;
          }
          else {
            this.router.navigate(['/Addorder']);
            return;
          }
          // type === 0 أو أي حاجة تانية → مفيش action
        },
        error: (err) => console.error(err),
      });
  }
  accStatement(phone: any) {
    this.router.navigate(['/accountstatement'], { queryParams: { phone: phone } });
  }
  applyWareHouse(warehouseId: any) {
    this.warehouseId = warehouseId;
    this.getAllClients(10, 1, warehouseId);
  }

  goToCreateClient(): void {
    if (this.warehouseId) {
      localStorage.setItem('posId', String(this.warehouseId));
    }

    this.router.navigate(['/createclient']);
  }

  search() {
    if (this.searchKey != null && this.searchKey != undefined && this.searchKey != "") {
      this.contentReady = true;
      this._clientsService.searchClients(this.searchKey, this.warehouseId, !this.isAdmin && !this.isSubAdmin ? this.userId : null).subscribe({
        next: (data: any) => {


          this.allData = data['clients'];
          this.dataSource = new MatTableDataSource(this.allData);
          this.contentReady = false;
          if (this.allData.length === 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
        },
        error: (error) => console.error(error),
      });
    }

  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel('orderstable', 'Orders', ['actions']);
  }

  getAllClientsforUser(perpage: any, page: any, userId: any) {
    this.contentReady = true;
    this.searched = false;
    this._clientsService.getClientsUserLvl(perpage, page, userId).subscribe({
      next: (data) => {
        this.allData = data['data'];
        this.stockTotal = data['total'];
        this.totalItems = data['last_page'];

        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
  getAllClients(perpage: any, page: any, warehouse_id: any) {
    this.contentReady = true;
    this.searched = false;
    this._clientsService.getClients(perpage, page, warehouse_id).subscribe({
      next: (data) => {
        this.allData = data.clients['data'];
        this.stockTotal = data.clients['total'];
        this.totalItems = data.clients['last_page'];
        this.totaldebit = data.total_debt
        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
  onPaginateChange(event: PageEvent) {
    const newPage = event.pageIndex + 1; // MatPaginator is 0-based
    this.getAllClients(10, newPage, this.warehouseId);
  }
  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  call(phone: any) {
    window.open("tel:+" + phone, '_blank');
  }
  chat(phone: any) {
    // href="https://api.whatsapp.com/send?phone=201012673672"

    window.open("https://api.whatsapp.com/send?phone=2" + phone, '_blank');
  }
  reOrder(clientinfo: any) {

    localStorage.setItem("clientinfo", JSON.stringify(clientinfo))
    this.checkWarehouseType();
  }
  addPet(id: any) {
    this.router.navigate(['/pets'], { queryParams: { id } });
  }

  getClientproducts(obj: any) {
    if (typeof obj === 'string') {
      try {
        obj = JSON.parse(obj);
      } catch (e) {
        console.error('Invalid JSON', e);
        return;
      }
    }

    const hasProducts = Array.isArray(obj) && obj.length > 0;

    this.popupType = 'products';
    this.popupTitle = this.isAr ? 'المنتجات' : 'Products';
    this.selectedProducts = hasProducts ? obj : [];
    this.showClientPopup = true;
  }

  getClientOrders(obj: any) {
    if (typeof obj === 'string') {
      try {
        obj = JSON.parse(obj);
      } catch (e) {
        console.error('Invalid JSON', e);
        return;
      }
    }

    const hasOrders = Array.isArray(obj) && obj.length > 0;

    this.popupType = 'orders';
    this.popupTitle = this.isAr ? 'الطلبات' : 'Orders';
    this.selectedOrders = hasOrders ? obj : [];
    this.showClientPopup = true;
  }
  closeClientPopup() {
    this.showClientPopup = false;
    this.popupType = null;
    this.selectedOrders = [];
    this.selectedProducts = [];
    this.popupTitle = '';
  }
  getCategoryName(categoryId: string): string {

    return CATEGORY_NAMES[categoryId] ?? '-';
  }
}
